var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:`loader-wrapper-${_vm.identifier}`,class:{'opacity-0': _vm.enableInitialMountFadeIn},style:({width: _vm.wrapperDimensions.width, height: _vm.wrapperDimensions.height})},[_c('transition',[(_vm.contentInView)?_c('div',[_vm._t("default",null,{"handleMediaLoaded":_vm.handleMediaLoaded})],2):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }